// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.effects-editor {
  display: flex;
  flex-direction: row;
  overflow: auto;
  flex-grow: 1;
  background: dimgrey;
  border-radius: 3px;
}

.effects-editor .effects-list {
  overflow-y: scroll;
  flex: 0 0 auto;
  border-radius: 3px;
  margin: 3px;
  padding: 3px;
  background: black;
}

.effects-editor .effects-chain {
  border-radius: 3px;
  margin: 3px;
  background: black;
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  overflow: auto;
}

.effect-control-panel:last-child {
  border-right: 2px solid black;
}

.effects-editor .effects-chain .effect-control-panel {
  background-color: dimgrey;
  border-radius: 3px;
  flex: 0 0 auto;
  min-width: 200px;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  border-left: 2px solid black;
}

.effect-control-panel .effect-header {
  margin: 2px;
  font-size: 0.75em;
  color: white;
  background-color: #444;
  border-radius: 3px;
  padding: 1px 3px;
  display: flex;
  flex-direction: row;
}

.effect-control-panel .control-group .label {
  margin-right: 5px;
}

.effect-control-panel .control-group .slider {
  flex: 1 0 auto;
  margin-right: 5px;
  margin-left: 5px;
}

.effect-header .name {
  flex: 1 0 auto;
}

.effect-header .bypass {
  flex: 0 0 auto;
}

.effects-editor .effects-list .effect-name {
  color: white;
  font-size: 0.75em;
}

.sortable-placeholder {
  border: 1px dotted white;
  border-radius: 3px;
  margin-right: 3px;
}

button.delete {
  border: 1px solid black;
  background-color: #888;
  color: darkred;
  border-radius: 3px;
  padding: 0 3px;
  margin-right: 5px;
}

.effects-location {
  background: dimgrey;
  display: flex;
  flex-direction: column;
}

.effects-location .location-name {
  font-family: monospace;
  font-size: 12px;
  color: white;
}

.effects-location .location-controls {
  flex: 1;
  border: 1px solid black;
  margin: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/effects_editor/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".effects-editor {\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  flex-grow: 1;\n  background: dimgrey;\n  border-radius: 3px;\n}\n\n.effects-editor .effects-list {\n  overflow-y: scroll;\n  flex: 0 0 auto;\n  border-radius: 3px;\n  margin: 3px;\n  padding: 3px;\n  background: black;\n}\n\n.effects-editor .effects-chain {\n  border-radius: 3px;\n  margin: 3px;\n  background: black;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n}\n\n.effect-control-panel:last-child {\n  border-right: 2px solid black;\n}\n\n.effects-editor .effects-chain .effect-control-panel {\n  background-color: dimgrey;\n  border-radius: 3px;\n  flex: 0 0 auto;\n  min-width: 200px;\n  border-top: 2px solid black;\n  border-bottom: 2px solid black;\n  border-left: 2px solid black;\n}\n\n.effect-control-panel .effect-header {\n  margin: 2px;\n  font-size: 0.75em;\n  color: white;\n  background-color: #444;\n  border-radius: 3px;\n  padding: 1px 3px;\n  display: flex;\n  flex-direction: row;\n}\n\n.effect-control-panel .control-group .label {\n  margin-right: 5px;\n}\n\n.effect-control-panel .control-group .slider {\n  flex: 1 0 auto;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.effect-header .name {\n  flex: 1 0 auto;\n}\n\n.effect-header .bypass {\n  flex: 0 0 auto;\n}\n\n.effects-editor .effects-list .effect-name {\n  color: white;\n  font-size: 0.75em;\n}\n\n.sortable-placeholder {\n  border: 1px dotted white;\n  border-radius: 3px;\n  margin-right: 3px;\n}\n\nbutton.delete {\n  border: 1px solid black;\n  background-color: #888;\n  color: darkred;\n  border-radius: 3px;\n  padding: 0 3px;\n  margin-right: 5px;\n}\n\n.effects-location {\n  background: dimgrey;\n  display: flex;\n  flex-direction: column;\n}\n\n.effects-location .location-name {\n  font-family: monospace;\n  font-size: 12px;\n  color: white;\n}\n\n.effects-location .location-controls {\n  flex: 1;\n  border: 1px solid black;\n  margin: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
